import { render, staticRenderFns } from "./GoetheLogo.vue?vue&type=template&id=170df776&scoped=true&"
import script from "./GoetheLogo.vue?vue&type=script&lang=js&"
export * from "./GoetheLogo.vue?vue&type=script&lang=js&"
import style0 from "./GoetheLogo.vue?vue&type=style&index=0&id=170df776&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170df776",
  null
  
)

export default component.exports